/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".not-approved-header__container[_ngcontent-%COMP%]{margin-top:2px}.not-approved-header__text[_ngcontent-%COMP%]{font-size:15px;line-height:25px;background-color:#ccf;color:#000;position:relative;width:100%;z-index:10;display:flex;flex-direction:column;padding:5px}.not-approved-header__title[_ngcontent-%COMP%]{font-weight:700;font-size:larger}"];
export { styles as styles };
